import { DeleteIcon, ViewDocumentIcon } from 'Assets/icons'
import { CommonToolTip, CstmPagination } from 'components/Common/Common'
import AddReceiptsModal from 'components/Modals/AddReceiptsPop'
import ConfirmationPop from 'components/Modals/ConfirmationPop'
import ErrorComponent from 'components/shared/ErrorComponent'
import TableHeader from 'components/shared/FormComponents/TableHeader'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import LoadingOverlay from 'components/shared/LoadingOverlay'
import TableLayout from 'components/TableLayout'
import { CLIENT_ASSIGNED_COSNENT_FORMS_VIEW } from 'config/paths'
import { convertToMomentDate, successMessageToast } from 'helpers/common'
import React, { useState } from 'react'
import { Button, Dropdown, Row } from 'react-bootstrap'
import parse from "html-react-parser";
import { Link, useParams } from 'react-router-dom'
import { useDeleteReceiptFormMutation, useGetReceiptsListQuery } from 'store/services/receipts'
import { useGetResourcesListQuery } from 'store/services/resource'
import { useGetReportOptionsQuery, useLazyGetFileUrlQuery } from 'store/services/utility'

export const ManageResources = () => {
    const { id, parentId } = useParams()
    const pageSize = 10
    const [currentPage, setCurrentPage] = useState(1)
    const [filter, setFilter] = useState({ search: "", })
    const [modalType, setModalType] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [receiptsModal, setReceiptsModal] = useState(false)

    const { data, isLoading, isFetching, isError } = useGetResourcesListQuery({ id, page: currentPage, limit: pageSize, parentId, ...filter });
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
    const [deleteReceipt, { isLoading: deleteReceiptLoading }] = useDeleteReceiptFormMutation()
    const { data: reportOptions, isLoading: reportOptionsLoading } = useGetReportOptionsQuery()

    const column = [
        {
            head: "Name",
            accessor: "attachment_name",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.attachment_name ? `${parse(item?.attachment_name)} - ${item?.therapistResources?.therapist_detail?.therapist_designation?.title} - ${convertToMomentDate(item?.createdAt)}` : "--"}</h6>
            ),
        },
        {
            head: "Published",
            accessor: "is_published",
            isComponent: true,
            component: (item, ind) => (
                <p
                    style={{ width: 80 }}
                    className={`${item.is_published == "yes"
                        ? "greenStatus"
                        : "redStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {item.is_published}
                </p>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    {/* <CommonToolTip
                text={"Checlist"}
                component={<Button
                  className="p-0"
                  variant="transparent"
                  type="button"
                  onClick={() => { setCurrentEntry(item); setCheckListModal(true) }}
                >
                  <CheckIcon />
                </Button>}
              /> */}
                    {/* <CommonToolTip
                        text={"Delete"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={() => {

                                setCurrentEntry(item);
                                setModalType("delete");
                                setShowModal(true);
                            }}
                        >
                            <DeleteIcon />
                        </Button>}
                    /> */}
                    <CommonToolTip
                        text={"View"}
                        component={<Button
                            onClick={() => handleViewPdf(item?.attachment_key)}
                            className="p-0"
                            variant="transparent"
                            type="button"
                        >
                            <ViewDocumentIcon />
                        </Button>}
                    />
                </div>
            ),
        },
    ]

    const resetFilter = () => {
        setFilter({ search: "", appointment_type: "", status: "active" });
        setCurrentPage(1)
    };

    const handleFilterChange = (key) => (value) => {
        setFilter({ ...filter, [key]: value })
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };
    console.log('currentEntry', currentPage)
    const handleDeleteAppointment = async () => {
        try {

            setShowModal(false);

            // const list = [...therapistProfiles];
            // const index = therapistProfiles?.findIndex(x => x.id === currentEntry?.id);
            // delete list[index];
            // setTherapistProfiles(list.filter(Boolean));

            const response = await deleteReceipt({ id: currentEntry?.id }).unwrap();
            console.log('result response', response)
            successMessageToast(response?.message);

        } catch (err) {
            console.log("error deleting appointment", err);
        }
    };

    const handleViewPdf = async (name) => {

        try {
            const url = await getFileUrl(name).unwrap();
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };


    return (

        <>
            <AddReceiptsModal show={receiptsModal} setShow={setReceiptsModal} />
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={modalType == "delete" ? handleDeleteAppointment : handleDeleteAppointment}
                type={modalType}
            />
            <div className="TableFilter d-flex align-items-end justify-content-between gap-10  ">
                <div className="left">
                    <TableHeader
                        heading={"Reports"}
                        hideStatusFilter
                        handleFilterChange={handleFilterChange}
                        resetFilter={resetFilter}
                        filter={filter}
                        searchPlaceholder="Report name"
                        filterComponent={
                            <li className="">
                                <Dropdown
                                    onSelect={handleFilterChange("attachment_name")}>
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="border-0 d-flex align-items-center  justify-content-center"
                                        id="dropdown-basic"
                                    >
                                        {reportOptions?.find(x => x?.title == filter.attachment_name)?.title || "Report Type"}
                                        <span className="icn ms-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="12"
                                                height="8"
                                                viewBox="0 0 12 8"
                                                fill="none"
                                            >
                                                <path
                                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                    fill="black"
                                                />
                                            </svg>
                                        </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu >
                                        {
                                            reportOptions?.map((item, index) => {
                                                return <Dropdown.Item
                                                    key={index}
                                                    eventKey={item?.title}
                                                    style={filter.attachment_name == item.id ? { background: "#f3f3f3" } : {}}
                                                >
                                                    {item?.title}
                                                </Dropdown.Item>
                                            })
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </li>
                        }
                    >
                    </TableHeader>
                </div>
                <div className="right">
                    <ul style={{ marginBottom: "13px" }} className="list-unstyled ps-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                        <li className="">
                        </li>
                    </ul>
                </div>
            </div>
            <div className="table-outer">
                {isLoading ? (
                    <div style={{ height: "200px" }}>
                        <LoadingIndicator />
                    </div>
                ) : isError ? (
                    <ErrorComponent />
                ) : (
                    <>
                        {(isFetching || deleteReceiptLoading || reportOptionsLoading || getFileLoading) && (
                            <LoadingOverlay />
                        )}
                        <TableLayout data={data?.records} column={column} />
                    </>
                )}
                <CstmPagination
                    totalPages={totalPages}
                    activePage={currentPage}
                    handlePageChange={handlePageChange}
                />
            </div>
        </>


    )
}
